module.exports = __webpack_public_path__ + "fdf015e4c1573615cba3bb349166f5e5.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_12.jpg
 ** module id = 594
 ** module chunks = 0
 **/